export default class IdValueObj {
    constructor() {
      this.id="@id";
      this.value="";
    }

    setValue(value) {
      this.value=value;
    }

    getValue(lang) {
      return this.value;
    }


    parseInputJSON(inputJSON, objKey) {
      const obj=inputJSON[objKey];
      if (Array.isArray(obj)) {
        for (const entry of Object.entries(obj)) {
          const value=entry[1];
          this.setValue(value[this.id]);
        }
      } else {
        this.setValue(obj[this.id]);
      }
    }

    parseJsonObj(jsonObj) {
      this.setValue(jsonObj[this.id]);
    }

    print() {
      console.log(this.id+": "+this.value);
    }

    getExpandedFormatValue() {
      return {[this.id]: this.value};
    }

    isEmpty() {
      return !this.value;
    }
  }
